const HERO_IMAGE = 'https://public.readdy.ai/ai/img_res/a15437276d41e78862dcbf751336497c.jpg';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ minHeight: '100svh' }}
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={HERO_IMAGE}
          alt="Confident person in West Texas sunlight"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/45 to-black/25" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 py-32 flex flex-col lg:flex-row items-center lg:items-start gap-12">
        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left">
          {/* Tag */}
          <span className="inline-block border border-[#C8C8A0]/60 text-[#E8E4C8] text-sm font-medium px-5 py-2 rounded-full mb-8 tracking-wide">
            Life Coaching in Lubbock, Texas
          </span>

          {/* Headline */}
          <h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: '\'Playfair Display\', serif' }}
          >
            It&apos;s Time for a
            <br />
            <span className="text-[#E8B89A] italic">Brand New You</span>
          </h1>

          {/* Subheadline */}
          <p
            className="text-xl md:text-2xl text-white/85 font-light mb-6 leading-relaxed"
            style={{ fontFamily: '\'Playfair Display\', serif' }}
          >
            Discover the <em>strategies</em> you need to accomplish your goals{' '}
            <em>faster</em> than you ever imagined.
          </p>

          {/* Supporting Copy */}
          <p className="text-base md:text-lg text-white/75 mb-10 leading-relaxed max-w-lg" style={{ fontFamily: 'Inter, sans-serif' }}>
            Have you ever looked in the mirror and thought, &ldquo;Wow&hellip; I should be further ahead
            in life right now?&rdquo; You&apos;re not alone — and you do not have to figure it all out by
            yourself. At Brand New You, we help people in Lubbock and beyond find clarity, build
            momentum, and move forward with confidence.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <button
              onClick={() => scrollTo('consultation')}
              className="bg-[#D4896A] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#c07a5a] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-0.5"
            >
              Book Your Free Consultation
            </button>
            <button
              onClick={() => scrollTo('solution')}
              className="border-2 border-white/70 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Get More Info
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/60">
        <span className="text-xs tracking-widest uppercase" style={{ fontFamily: 'Inter, sans-serif' }}>Scroll</span>
        <div className="w-px h-10 bg-white/40 animate-pulse" />
      </div>
    </section>
  );
}
